import axios from './api'

export const getImage = (token = '', src = '') => {
  return axios({
    method: 'POST',
    url: `/vademecum/images/${src}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  })
    .then(res => res.data.data)
}